import { type ReactElement } from 'react';
import { type EmptyLayoutProps } from '@/layout/types';
import { EmptyLayoutLanguageSelector } from '@/shared/components/LanguageSelector';
export function getEmptyLayout(page: ReactElement, showLanguageSelector = false) {
  return <EmptyLayout showLanguageSelector={showLanguageSelector} data-sentry-element="EmptyLayout" data-sentry-component="getEmptyLayout" data-sentry-source-file="getEmptyLayout.tsx">
      {page}
    </EmptyLayout>;
}
export const EmptyLayout = (props: EmptyLayoutProps) => {
  const {
    showLanguageSelector = false,
    children
  } = props;
  return <>
      {showLanguageSelector && <EmptyLayoutLanguageSelector />}
      {children}
    </>;
};